import type { VisualManifestEntry } from './types'
import { ENEMY_VISUALS } from './enemies'
import { PROJECTILE_VISUALS } from './projectiles'
import { TERRAIN_VISUALS, TOWER_VISUALS } from './towers'

/**
 * Manifest for future sprite/SVG replacement.
 * M26 entries are procedural — no runtime bitmap URLs.
 */
export const VISUAL_MANIFEST: VisualManifestEntry[] = [
    ...Object.values(TERRAIN_VISUALS).map((v) => ({
    id: v.id,
    category: 'terrain' as const,
    kind: v.kind
  })),
  ...Object.values(TOWER_VISUALS).map((v) => ({
    id: v.id,
    category: 'tower' as const,
    kind: v.kind,
    source: v.assetKey
  })),
  ...Object.values(ENEMY_VISUALS).map((v) => ({
    id: v.id,
    category: 'enemy' as const,
    kind: v.kind,
    source: v.assetKey
  })),
  ...Object.values(PROJECTILE_VISUALS).map((v) => ({
    id: v.id,
    category: 'projectile' as const,
    kind: v.kind,
    source: v.assetKey
  }))
]
